import React, { useEffect, useState } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { generateTokenByApiKey } from "../api/login";
import { SHOW_SNACKBAR } from "../utils/types";
import { getEmailBody } from "../utils/helper";

const HomePage = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h7-testimonial-slider", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".h5-story-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".h5-story-next",
        prevEl: ".h5-story-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);
    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }

  return (
    <main>
      <section id="home-one-hero">
        <div className="hero-one-section-wrapper bg-[#ffffff] w-full xl:h-[805px] overflow-hidden relative">
          <div className="theme-container mx-auto h-full relative z-10 pointer-events-none">
            <div className="w-full grid xl:grid-cols-2 grid-cols-1 2xl:gap-[130px] gap-10 items-center pt-[80px] h-full">
              <div className="article-area">
                <div className="inline-flex md:px-6 max-md:mt-6 px-3 py-2.5 md:py-[14px] bg-white space-x-2.5 items-center rounded-full shadow-style-one mb-5">
                  <span>
                    <svg
                      width={24}
                      height={21}
                      viewBox="0 0 24 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.2905 11.6848C16.2905 11.6848 17.3263 9.76839 17.6802 9.28446C17.6802 9.28446 18.0635 8.72533 18.4291 9.12672L18.1586 10.3716L16.6337 12.4303L15.74 12.6245L16.2905 11.6848Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M7.73128 11.6848C7.73128 11.6848 6.69556 9.76839 6.34165 9.28446C6.34165 9.28446 5.95833 8.72533 5.59277 9.12672L5.86323 10.3716L7.38808 12.4303L8.28183 12.6245L7.73128 11.6848Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M14.7651 8.22397V9.73964C14.7651 9.96706 14.5804 10.1516 14.3532 10.1516H9.64658C9.41916 10.1516 9.23462 9.9669 9.23462 9.73964V8.22397C9.23462 7.99655 9.41931 7.81201 9.64658 7.81201H14.3532C14.423 7.81201 14.4878 7.82871 14.545 7.85995H14.5461C14.6764 7.92978 14.7651 8.06638 14.7651 8.22397Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M12.7576 11.7468H11.2418C11.0142 11.7468 10.8298 11.5624 10.8298 11.3348V6.62827C10.8298 6.40069 11.0142 6.21631 11.2418 6.21631H12.7576C12.9852 6.21631 13.1696 6.40069 13.1696 6.62827V11.3348C13.1696 11.5624 12.9852 11.7468 12.7576 11.7468Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M23.721 9.67746C23.2655 12.0146 21.5783 14.5808 18.8407 17.1008C18.8335 17.108 18.8248 17.1154 18.8174 17.1226L14.6743 20.6594C14.5133 20.7957 14.313 20.8669 14.1086 20.8669C13.962 20.8669 13.8141 20.8306 13.6792 20.7538C13.3992 20.5942 13.2396 20.2822 13.2396 19.9602V14.7534C13.2396 14.6998 13.2439 14.6476 13.2542 14.5952C13.2658 13.822 13.4151 12.9371 13.9476 12.3872C15.4418 10.8421 15.4042 10.0776 15.9278 9.95434C16.7575 9.75847 16.5457 11.3455 16.0786 12.1536C16.1802 12.0434 17.8079 10.2504 18.4288 9.12598C19.07 7.96546 20.3278 8.31509 19.6052 9.71926C19.0409 10.8175 17.5946 13.1024 15.3996 14.8504C15.3996 14.8504 15.3982 14.8517 15.3953 14.8533C15.2647 14.9592 15.1617 15.0883 15.0907 15.2348C15.0196 15.3827 14.9804 15.5467 14.9804 15.715C14.9804 16.6319 16.0235 17.1382 16.7402 16.6014C16.7561 16.5913 16.7707 16.5797 16.7852 16.5666C16.794 16.5595 16.7998 16.555 16.7998 16.555L17.6745 15.8078C20.0944 13.578 21.635 11.2816 22.0136 9.34345C22.6781 5.93569 21.1852 3.3912 18.1154 2.70205C16.9592 2.44231 15.6913 2.7195 14.3508 3.52611C13.3064 4.15431 12.6404 4.85786 12.6332 4.86505C12.6303 4.86643 12.6274 4.86934 12.626 4.87087C12.6159 4.88098 12.6085 4.89262 12.5984 4.90273C12.5751 4.92447 12.5491 4.9404 12.5244 4.95924C12.5128 4.96797 12.4998 4.97808 12.4882 4.98681C12.4548 5.01008 12.42 5.02892 12.3837 5.04623C12.3678 5.05342 12.3519 5.06368 12.3344 5.0695C12.301 5.08405 12.2676 5.09416 12.2342 5.10289C12.2125 5.10871 12.1921 5.1159 12.1704 5.12034C12.1399 5.12616 12.1094 5.12908 12.0789 5.13199C12.0528 5.1349 12.0267 5.13627 12.0005 5.13627C11.9744 5.13627 11.9483 5.1349 11.9221 5.13199C11.8917 5.12908 11.8612 5.12616 11.8293 5.12034C11.809 5.11606 11.7872 5.10871 11.767 5.10289C11.7322 5.09416 11.6988 5.08405 11.6655 5.0695C11.6495 5.06368 11.6336 5.05358 11.6161 5.04623C11.5814 5.02877 11.5465 5.00993 11.5131 4.98681C11.5001 4.97808 11.4884 4.96797 11.4768 4.95924C11.4521 4.9404 11.4259 4.92447 11.4028 4.90273C11.3927 4.89262 11.3854 4.88098 11.3753 4.87087C11.3723 4.86949 11.3694 4.86659 11.3681 4.86505C11.3609 4.85786 10.695 4.15416 9.65039 3.52611C8.30854 2.7195 7.04204 2.44247 5.88427 2.70205C2.81602 3.3912 1.32317 5.93569 1.98766 9.34345C2.36624 11.2816 3.90702 13.578 6.3267 15.8078L7.20008 16.555C7.9168 17.1658 9.02066 16.6581 9.02066 15.715V15.6991C9.02066 15.3625 8.86537 15.0449 8.60288 14.8344C6.41813 13.0892 4.97903 10.8146 4.41607 9.71926C3.69369 8.31493 4.95131 7.96531 5.59268 9.12598C6.21353 10.2502 7.8413 12.0434 7.94283 12.1536C7.47574 11.3457 7.26394 9.75847 8.09368 9.95434C8.61743 10.0776 8.5796 10.8421 10.0738 12.3872C10.7049 13.0385 10.7991 14.1614 10.7614 15.0115V19.9599C10.7614 20.2819 10.6019 20.5939 10.3204 20.7535C10.1855 20.8303 10.0375 20.8666 9.89098 20.8666C9.68791 20.8666 9.48622 20.7956 9.32526 20.6591L5.18378 17.1226C5.17506 17.1154 5.16786 17.108 5.15913 17.1008C2.42305 14.581 0.734485 12.0146 0.278881 9.67746C-0.146247 7.4999 0.146871 5.52403 1.12761 3.96594C2.07496 2.4587 3.58802 1.43447 5.50294 1.00352C8.34055 0.366597 10.8633 2.11045 12.0007 3.07955C13.1381 2.11045 15.6608 0.36675 18.4969 1.00352C20.4134 1.43432 21.9264 2.45855 22.8738 3.96594C23.853 5.52403 24.1461 7.4999 23.721 9.67746Z"
                        fill="#F28775"
                      />
                      <path
                        d="M16.0742 12.1599C16.0742 12.1599 17.7631 10.3708 18.429 9.12646"
                        stroke="#AF493E"
                        strokeWidth="0.111657"
                        strokeMiterlimit={10}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.94752 12.1599C7.94752 12.1599 6.25864 10.3708 5.59277 9.12646"
                        stroke="#AF493E"
                        strokeWidth="0.111657"
                        strokeMiterlimit={10}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.7403 16.6017C16.3864 16.8817 14.5367 18.2831 14.1972 17.3156C13.7693 16.0941 15.3113 14.9175 15.3955 14.8538C15.2649 14.9597 15.162 15.0888 15.0909 15.2352C15.0199 15.3832 14.9807 15.5472 14.9807 15.7155C14.9805 16.6322 16.0236 17.1385 16.7403 16.6017Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M7.25635 16.6017C7.61026 16.8817 9.45994 18.2831 9.79946 17.3156C10.2275 16.0941 8.68534 14.9175 8.60111 14.8538C8.73174 14.9597 8.83465 15.0888 8.90571 15.2352C8.97677 15.3832 9.01598 15.5472 9.01598 15.7155C9.01613 16.6322 7.97306 17.1385 7.25635 16.6017Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M16.7853 16.5669C16.7751 16.5756 16.7606 16.5873 16.7402 16.6017C16.7562 16.5915 16.7707 16.5799 16.7853 16.5669Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M17.9547 4.88257C17.9547 4.88257 15.6276 5.13066 16.0593 7.55003C18.4861 7.16181 17.9547 4.88257 17.9547 4.88257Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M16.1719 7.3921L17.8441 5.03857"
                        stroke="#AF493E"
                        strokeWidth="0.145074"
                        strokeMiterlimit={10}
                      />
                      <path
                        d="M6.04514 4.88257C6.04514 4.88257 8.37232 5.13066 7.94061 7.55003C5.51373 7.16181 6.04514 4.88257 6.04514 4.88257Z"
                        fill="#D1675D"
                      />
                      <path
                        d="M7.82819 7.3921L6.15601 5.03857"
                        stroke="#AF493E"
                        strokeWidth="0.145074"
                        strokeMiterlimit={10}
                      />
                    </svg>
                  </span>
                  <span className="md:text-[16px] text-sm text-theme font-medium pointer-events-auto">
                    Care Nova, Always There
                  </span>
                </div>
                <h2 className="md:text-[50px] text-[40px] leading-[1.2em] text-main-black font-semibold mb-[35px] pointer-events-auto">
                  Discover Affordable & Reliable Healthcare With Care Nova
                </h2>
                <div className="py-[14px] mb-[35px] pointer-events-auto pr-6 xl:w-full md:w-[500px]">
                  <p className="text-black font-regular">
                    Goodbye to long waits and expensive appointments. Get timely
                    outpatient care tailored to your needs. Join the growing
                    family that relies on Care Nova for everyday health and
                    long-term wellness.
                  </p>
                </div>
                <div className="flex space-x-[30px] items-center pointer-events-auto">
                  <Link to="/plans">
                    <div className="home-two-btn-bg py-4 group bg-[#AF493E] border-[1px] border-[#AF493E]">
                      <span className="text-base text-white group-hover:text-[#AF493E] transition-all duration-300 font-semibold font-inter relative z-10">
                        Explore Our Plans
                      </span>
                      <svg
                        className="relative z-10"
                        width={7}
                        height={12}
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="group-hover:stroke-[#AF493E] transition-all duration-300"
                          d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="image-area relative h-full">
                <div className="xl:absolute relative 2xl:w-[752px] lg:w-[600px] w-full left-0 top-0 h-full">
                  {/* main image */}
                  <div className="xl:absolute relative left-0 md:left-[-50px] bottom-0 w-full z-10">
                    <div className="w-full flex justify-center">
                      <img src="assets/images/home-one-hero-main.webp" alt="" />
                    </div>
                  </div>
                  {/* tags */}
                  <div className="absolute left-[-50px] bottom-0 w-full h-full md:block hidden">
                    <div
                      id="hero-mouse-move-anim"
                      className="w-full relative h-full z-10 pointer-events-auto"
                    >
                      <div data-depth="0.20" className="layer">
                        <span className="inline-block xl:px-[30px] px-6 xl:py-2.5 py-1.5 bg-[#F28775] 2xl:text-pone xl:text-sm lg:text-pone text-white rounded-br-none rounded-full">
                          Unlimited Consultations
                        </span>
                      </div>
                      <div data-depth="0.30" className="layer">
                        <span className="inline-block xl:px-[30px] px-6 xl:py-2.5 py-1.5 bg-[#F28775] 2xl:text-pone xl:text-sm lg:text-pone text-white rounded-full rounded-bl-none">
                          Diagnostics & Lab Tests
                        </span>
                      </div>
                      <div data-depth="0.40" className="layer h-fit">
                        <span className="inline-block xl:px-[30px] px-6 xl:py-2.5 py-1.5 bg-[#F28775] 2xl:text-pone xl:text-sm lg:text-pone text-white rounded-br-none rounded-full h-fit">
                          Digital Health Records
                        </span>
                      </div>
                      <div data-depth="0.50" className="layer h-fit">
                        <span className="inline-block xl:px-[30px] px-6 xl:py-2.5 py-1.5 bg-[#F28775] 2xl:text-pone xl:text-sm lg:text-pone text-white rounded-full rounded-bl-none h-fit">
                          Dental & Scans
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* white circle */}
                  <div className="absolute left-0 bottom-[100px] w-full md:block hidden">
                    <div className="flex justify-center">
                      <div className="w-[533px] h-[585px] bg-white rounded-[266px]" />
                    </div>
                  </div>
                  {/* shadow */}
                  <div className="absolute left-0 bottom-0 w-full overflow-hidden">
                    <div className="flex justify-center">
                      <img
                        src="assets/images/home-one-hero-circle-shadow.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about start */}
      <div className="bg-[#23100E]">
        {/* partner start  */}
        <section className="bg-[#23100E]">
          <div className="max-w-[1616px] mx-auto">
            <div className="w-full pt-[60px] xl:pt-[123px]">
              <h1 className="w-full text-center md:mb-[100px] font-medium text-white">
                We’ve more then 1250+ global clients
              </h1>
              <center className="min-md:px-[200px]">
                <div className="swiper h3-partner_slider mt-11 overflow-hidden">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide" data-aos="fade-up">
                      <img src="assets/images/partner_logo/1.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={100}
                    >
                      <img src="assets/images/partner_logo/2.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={200}
                    >
                      <img src="assets/images/partner_logo/4.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={300}
                    >
                      <img src="assets/images/partner_logo/5.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={400}
                    >
                      <img src="assets/images/partner_logo/6.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img src="assets/images/partner_logo/7.svg" alt="" />
                    </div>

                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img src="assets/images/partner_logo/8.svg" alt="" />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/9.png"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/10.png"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/11.png"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/12.png"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/13.svg"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                    <div
                      className="swiper-slide"
                      data-aos="fade-up"
                      data-aos-delay={500}
                    >
                      <img
                        src="assets/images/partner_logo/14.png"
                        alt=""
                        className="h-[60px]"
                      />
                    </div>
                  </div>
                </div>
              </center>
            </div>
          </div>
        </section>
        {/* partner end  */}
        <div className="h-[40px]"></div>
        <section className="bg-[#23100E] py-[70px] sm:py-[130px]">
          <div className="theme-container mx-auto grid grid-cols-7 lg:grid-cols-12">
            <div className="col-span-6 md:col-span-7" data-aos="fade">
              <div className="relative w-fit">
                <img
                  src="assets/images/home-seven/about.png"
                  alt=""
                  className=""
                />
                <div className="w-[100px] aspect-square rounded-[10px] bg-[#54221D] flex justify-center items-center absolute -top-[50px] -right-[50px]">
                  <svg
                    width={93}
                    height={78}
                    className="scale-[0.6]"
                    viewBox="0 0 93 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M63.1848 42.1895C63.1848 42.1895 67.224 34.7154 68.6043 32.828C68.6043 32.828 70.0993 30.6474 71.5249 32.2128L70.4702 37.068L64.5232 45.097L61.0376 45.8543L63.1848 42.1895Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M29.8038 42.1895C29.8038 42.1895 25.7645 34.7154 24.3842 32.828C24.3842 32.828 22.8893 30.6474 21.4636 32.2128L22.5184 37.068L28.4653 45.097L31.951 45.8543L29.8038 42.1895Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M57.2359 28.6931V34.6042C57.2359 35.4911 56.5156 36.2108 55.6293 36.2108H37.2736C36.3867 36.2108 35.667 35.4905 35.667 34.6042V28.6931C35.667 27.8061 36.3873 27.0864 37.2736 27.0864H55.6293C55.9016 27.0864 56.1543 27.1515 56.3777 27.2734H56.3818C56.8901 27.5457 57.2359 28.0785 57.2359 28.6931Z"
                      fill="#AF493E"
                    />
                    <path
                      d="M49.4065 42.432H43.4948C42.6073 42.432 41.8882 41.7129 41.8882 40.8253V22.4697C41.8882 21.5821 42.6073 20.863 43.4948 20.863H49.4065C50.2941 20.863 51.0132 21.5821 51.0132 22.4697V40.8253C51.0132 41.7129 50.2941 42.432 49.4065 42.432Z"
                      fill="#AF493E"
                    />
                    <path
                      d="M92.1633 34.361C90.3871 43.4758 83.807 53.4842 73.1303 63.3121C73.1023 63.3402 73.0682 63.3688 73.0396 63.3969L56.8812 77.1907C56.2535 77.7223 55.4723 78 54.6749 78C54.1034 78 53.5264 77.8584 53.0002 77.5586C51.9084 76.9363 51.2861 75.7196 51.2861 74.4636V54.1573C51.2861 53.9482 51.3028 53.7446 51.3428 53.5403C51.3882 50.5247 51.9705 47.0737 54.0472 44.929C59.8747 38.9032 59.7278 35.9217 61.7698 35.4409C65.0058 34.677 64.1798 40.8664 62.3581 44.0181C62.7541 43.5881 69.1024 36.5954 71.5237 32.2103C74.0245 27.6842 78.9298 29.0478 76.1119 34.5241C73.911 38.807 68.2704 47.7182 59.7099 54.5353C59.7099 54.5353 59.7045 54.5407 59.6931 54.5467C59.1837 54.96 58.7823 55.4635 58.5052 56.0345C58.228 56.6114 58.0751 57.2511 58.0751 57.9075C58.0751 61.4833 62.1431 63.4578 64.9383 61.3644C65.0004 61.325 65.0571 61.2796 65.1139 61.2289C65.1479 61.2008 65.1706 61.1835 65.1706 61.1835L68.5822 58.2694C78.0195 49.5733 84.028 40.6173 85.5044 33.0584C88.096 19.7681 82.2738 9.84458 70.3017 7.1569C65.7924 6.14394 60.8476 7.22498 55.6198 10.3708C51.5465 12.8207 48.949 15.5646 48.9209 15.5926C48.9096 15.598 48.8982 15.6094 48.8928 15.6153C48.8534 15.6547 48.8247 15.7001 48.7853 15.7396C48.6945 15.8244 48.593 15.8865 48.4969 15.9599C48.4515 15.994 48.4007 16.0334 48.3553 16.0675C48.2251 16.1582 48.0895 16.2317 47.948 16.2992C47.8859 16.3273 47.8237 16.3673 47.7556 16.39C47.6254 16.4467 47.4952 16.4861 47.365 16.5202C47.2802 16.5429 47.2008 16.5709 47.116 16.5883C46.9971 16.611 46.8783 16.6223 46.7594 16.6337C46.6573 16.645 46.5558 16.6504 46.4536 16.6504C46.3515 16.6504 46.25 16.645 46.1478 16.6337C46.029 16.6223 45.9101 16.611 45.7859 16.5883C45.7064 16.5715 45.6216 16.5429 45.5428 16.5202C45.4072 16.4861 45.277 16.4467 45.1468 16.39C45.0847 16.3673 45.0226 16.3279 44.9545 16.2992C44.8189 16.2311 44.6827 16.1576 44.5525 16.0675C44.5018 16.0334 44.4564 15.994 44.411 15.9599C44.3148 15.8865 44.2127 15.8244 44.1225 15.7396C44.0831 15.7001 44.0544 15.6547 44.015 15.6153C44.0036 15.6099 43.9923 15.5986 43.9869 15.5926C43.9589 15.5646 41.362 12.8201 37.288 10.3708C32.0548 7.22498 27.1155 6.14454 22.6001 7.1569C10.634 9.84458 4.81188 19.7681 7.4034 33.0584C8.87984 40.6173 14.8889 49.5733 24.3256 58.2694L27.7318 61.1835C30.527 63.5654 34.8321 61.5854 34.8321 57.9075V57.8454C34.8321 56.5326 34.2265 55.2939 33.2028 54.4732C24.6822 47.6668 19.0697 38.7957 16.8742 34.5241C14.0569 29.0472 18.9616 27.6836 21.463 32.2103C23.8843 36.5948 30.2326 43.5881 30.6286 44.0181C28.8069 40.867 27.9809 34.677 31.2169 35.4409C33.2595 35.9217 33.112 38.9032 38.9395 44.929C41.4008 47.4691 41.7681 51.8483 41.6212 55.1637V74.4624C41.6212 75.7185 40.9988 76.9351 39.9011 77.5574C39.3749 77.8573 38.7979 77.9988 38.2263 77.9988C37.4344 77.9988 36.6478 77.7217 36.02 77.1895L19.8683 63.3969C19.8342 63.3688 19.8062 63.3402 19.7721 63.3121C9.10142 53.4848 2.51601 43.4758 0.739151 34.361C-0.91885 25.8685 0.224311 18.1627 4.04918 12.0861C7.74384 6.20785 13.6448 2.21336 21.113 0.532662C32.1796 -1.95135 42.0183 4.84967 46.4542 8.62915C50.8901 4.84967 60.7288 -1.95076 71.7895 0.532662C79.2636 2.21276 85.1646 6.20725 88.8593 12.0861C92.6782 18.1627 93.8213 25.8685 92.1633 34.361Z"
                      fill="#F28775"
                    />
                    <path
                      d="M62.3413 44.0432C62.3413 44.0432 68.9279 37.0654 71.5248 32.2126"
                      stroke="#AF493E"
                      strokeWidth="0.435464"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M30.6471 44.0432C30.6471 44.0432 24.0605 37.0654 21.4636 32.2126"
                      stroke="#AF493E"
                      strokeWidth="0.435464"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M64.9384 61.3657C63.5581 62.4575 56.3444 67.9231 55.0203 64.1496C53.3515 59.3858 59.3654 54.797 59.6938 54.5486C59.1844 54.9619 58.783 55.4654 58.5059 56.0364C58.2288 56.6133 58.0759 57.253 58.0759 57.9094C58.0753 61.4846 62.1432 63.4591 64.9384 61.3657Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M27.9517 61.3657C29.3319 62.4575 36.5457 67.9231 37.8698 64.1496C39.5392 59.3858 33.5247 54.797 33.1962 54.5486C33.7057 54.9619 34.107 55.4654 34.3842 56.0364C34.6613 56.6133 34.8142 57.253 34.8142 57.9094C34.8148 61.4846 30.7468 63.4591 27.9517 61.3657Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M65.1138 61.2302C65.0744 61.2643 65.0177 61.3097 64.9382 61.3658C65.0003 61.3264 65.0571 61.281 65.1138 61.2302Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M69.6753 15.6614C69.6753 15.6614 60.5993 16.6289 62.283 26.0645C71.7478 24.5504 69.6753 15.6614 69.6753 15.6614Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M62.7219 25.4483L69.2434 16.2695"
                      stroke="#AF493E"
                      strokeWidth="0.565787"
                      strokeMiterlimit={10}
                    />
                    <path
                      d="M23.2279 15.6614C23.2279 15.6614 32.3039 16.6289 30.6202 26.0645C21.1554 24.5504 23.2279 15.6614 23.2279 15.6614Z"
                      fill="#D1675D"
                    />
                    <path
                      d="M30.1812 25.4483L23.6597 16.2695"
                      stroke="#AF493E"
                      strokeWidth="0.565787"
                      strokeMiterlimit={10}
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="col-span-7 md:col-span-5">
              <div className="flex items-center h-full">
                <div className="mt-10 md:mt-0">
                  <h1 className="px-5 bg-white/10 border mb-[40px] py-2 border-white/20 text-white font-medium rounded-[30px] w-fit">
                    About Company
                  </h1>
                  <h2 className="max-w-[747px] font-medium text-24 sm:text-[36px] text-white mt-5">
                    Built on Care. Backed by Trust.
                  </h2>
                  <p className="text-white mt-9">
                    At Care Nova, we believe healthcare should be simple,
                    affordable, and always available when you need it. Founded
                    with a vision to revolutionize outpatient services and
                    preventive care, we offer OPD and wellness plans that are
                    designed to empower individuals and families to take charge
                    of their health — without financial strain or complex
                    processes.
                  </p>
                  <p className="text-white mt-4 mb-10">
                    With a wide network of healthcare providers and a commitment
                    to quality care, we stand by our promise: Care Nova, Always
                    There.
                  </p>
                  <Link to="/plans">
                    <div className="home-two-btn-bg py-4 group bg-[#AF493E] border-[1px] border-[#AF493E]">
                      <span className="text-base text-white group-hover:text-[#AF493E] transition-all duration-300 font-semibold font-inter relative z-10">
                        Explore Our Plans
                      </span>
                      <svg
                        className="relative z-10"
                        width={7}
                        height={12}
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="group-hover:stroke-[#AF493E] transition-all duration-300"
                          d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* about end */}

      {/* mission vision and goals start */}
      <section className="py-[70px] sm:py-[130px] bg-white">
        <div className="theme-container mx-auto w-full">
          <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit mx-auto">
            How it works
          </h1>
          <h2 className="max-w-[500px] font-semibold text-24 sm:text-48 text-main-black text-center mx-auto mt-5">
            Simple Steps to Smarter Healthcare
          </h2>
          <div
            className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-12 min-h-[303px] gap-[30px] mt-[70px]"
            data-aos="fade-up"
          >
            {/* single card  */}
            <div className="col-span-3 flex items-center h-full">
              <div className="group border border-[#AF493E20] px-[30px] py-[30px] rounded-2xl bg-white -right-0 h-[246px] hover:h-[290px] transition-all duration-300 hover:bg-it-gray overflow-hidden h5-story_slider_active_card">
                <div className="">
                  <img src="assets/images/plan.svg" alt="" />
                </div>
                <h1 className="text-18 font-semibold text-main-black mt-5 mb-2.5">
                  Choose a Plan
                </h1>
                <p className="text-paragraph line-clamp-3">
                  Select from our affordable OPD or wellness plans based on your
                  health needs.
                </p>
              </div>
            </div>
            {/* single card  */}
            <div className="col-span-3 flex items-center h-full">
              <div className="group border border-[#AF493E10] px-[30px] py-[30px] rounded-2xl bg-white -right-0 h-[246px] hover:h-[290px] transition-all duration-300 hover:bg-it-gray overflow-hidden h5-story_slider_active_card">
                <img src="assets/images/access.svg" alt="" />
                <h1 className="text-18 font-semibold text-main-black mt-5 mb-2.5">
                  Get Access Instantly
                </h1>
                <p className="text-paragraph line-clamp-3">
                  Once enrolled, enjoy instant access to our partnered
                  hospitals, clinics, and wellness centers.
                </p>
              </div>
            </div>
            {/* single card  */}
            <div className="col-span-3 flex items-center h-full">
              <div className="group border border-[#AF493E10] px-[30px] py-[30px] rounded-2xl bg-white -right-0 h-[246px] hover:h-[290px] transition-all duration-300 hover:bg-it-gray overflow-hidden h5-story_slider_active_card">
                <img src="assets/images/appointment.svg" alt="" />
                <h1 className="text-18 font-semibold text-main-black mt-5 mb-2.5">
                  Book Appointments Online
                </h1>
                <p className="text-paragraph line-clamp-3">
                  Use our platform to schedule appointments, track health
                  records, and connect with specialists.
                </p>
              </div>
            </div>
            {/* single card  */}
            <div className="col-span-3 flex items-center h-full">
              <div className="group border border-[#AF493E10] px-[30px] py-[30px] rounded-2xl bg-white -right-0 h-[246px] hover:h-[290px] transition-all duration-300 hover:bg-it-gray overflow-hidden h5-story_slider_active_card">
                <img src="assets/images/staysafe.svg" alt="" />
                <h1 className="text-18 font-semibold text-main-black mt-5 mb-2.5">
                  Stay Covered, Stay Healthy
                </h1>
                <p className="text-paragraph line-clamp-3">
                  Whether it's a minor illness or routine checkup, Care Nova has
                  you covered.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mission vision and goals end */}

      {/* testimonials start */}
      <section className="py-[70px] sm:py-[130px] bg-[#FEF9F6]">
        <div className="theme-container mx-auto w-full">
          <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit mx-auto">
            Our Testimonials
          </h1>
          <h2 className="max-w-[450px] font-semibold text-24 sm:text-48 text-main-black text-center mx-auto mt-5">
            Customer Say About Our Services
          </h2>
          <div className="w-full mt-[60px]" data-aos="fade-up">
            <div className="swiper h5-story-slider h7-testimonial-slider pt-14">
              <div className="swiper-wrapper pb-[50px]">
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      Care Nova makes doctor visits and tests hassle-free. I use
                      it for my parents too.
                    </h1>
                    <img
                      src="assets/images/vikram.png"
                      alt=""
                      className="mx-auto w-[56px] rounded-full"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Rohit Mehra
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      New Delhi
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      I love how everything is digital. No paperwork, just care.
                    </h1>
                    <img
                      src="assets/images/priya.png"
                      alt=""
                      className="mx-auto w-[56px] rounded-full"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Priya Nair
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      Bangalore
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      From kids to elders, one plan covers us all. Very helpful!
                    </h1>
                    <img
                      src="assets/images/anita.png"
                      alt=""
                      className="mx-auto w-[56px] rounded-full"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Anita & Kunal Sinha
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      Lucknow
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      Got my annual checkup and wellness consult without any
                      extra cost.
                    </h1>
                    <img
                      src="assets/images/home-seven/client-2.png"
                      alt=""
                      className="mx-auto"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Kunal Srivastava
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      Mumbai
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      Quick customer service and <br />a wide hospital network{" "}
                      <br></br> — very impressed.
                    </h1>
                    <img
                      src="assets/images/pooja.png"
                      alt=""
                      className="mx-auto w-[56px] rounded-full"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Neha Iyer
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      Hyderabad
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="flex flex-col items-center relative pt-[52px] pb-10 px-11 bg-white rounded-2xl h-[386px]">
                    <div className="w-[240px] aspect-square rounded-full card-shape-bg absolute" />
                    <svg
                      className="relative -top-3"
                      width={60}
                      height={46}
                      viewBox="0 0 60 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.9702 4.99404C53.2589 1.94822 49.9682 0.403809 46.1898 0.403809C42.7939 0.403809 39.9151 1.61307 37.6326 3.99783C35.3647 6.36736 34.2147 9.31052 34.2147 12.7458C34.2147 15.9921 35.3763 18.8849 37.6672 21.3439C39.688 23.5133 42.2336 24.8932 45.2472 25.4556C44.7202 29.4511 41.1881 33.0676 34.7278 36.2188L33.5645 36.7863L38.3341 45.5918L39.4108 45.046C53.0727 38.1209 59.9997 28.334 59.9997 15.957C59.9997 11.687 58.6441 7.99861 55.9702 4.99404ZM39.3601 42.2764L36.9704 37.8652C44.1567 34.0997 47.7976 29.5731 47.7976 24.3976V23.2895L46.6966 23.1648C43.7312 22.8292 41.3715 21.6804 39.4828 19.6527C37.6077 17.6397 36.6961 15.3806 36.6961 12.7458C36.6961 9.93232 37.5889 7.63217 39.4252 5.71334C41.2467 3.8101 43.4595 2.8849 46.1899 2.8849C49.2725 2.8849 51.8654 4.11443 54.1167 6.64357C56.4058 9.2156 57.5186 12.262 57.5186 15.9569C57.5186 21.6296 55.9213 26.7509 52.7711 31.1786C49.7653 35.4033 45.257 39.133 39.3601 42.2764Z"
                        fill="#AF493E"
                      />
                      <path
                        d="M22.3404 4.98842C19.599 1.94635 16.2947 0.403809 12.519 0.403809C9.11988 0.403809 6.25406 1.61529 4.0016 4.00451C1.76848 6.37311 0.636094 9.31405 0.636094 12.7458C0.636094 15.992 1.79766 18.8848 4.08832 21.3439C6.10488 23.5086 8.61996 24.8872 11.5775 25.4522C11.0569 29.4507 7.55414 33.069 1.14562 36.2208L0 36.784L4.65094 45.5958L5.73832 45.0471C19.4621 38.1224 26.4207 28.335 26.4207 15.9569C26.4206 11.6836 25.0477 7.99323 22.3404 4.98842ZM5.70223 42.2722L3.3777 37.8678C10.5118 34.1009 14.1267 29.5732 14.1267 24.3975V23.2918L13.0282 23.165C10.1236 22.8299 7.79297 21.681 5.90367 19.6526C4.02855 17.6398 3.11719 15.3805 3.11719 12.7458C3.11719 9.92869 3.99703 7.62608 5.80676 5.70666C7.5968 3.80799 9.79254 2.8849 12.519 2.8849C15.6047 2.8849 18.2146 4.11619 20.497 6.64932C22.8135 9.21994 23.9395 12.2646 23.9395 15.9569C23.9395 21.6287 22.3352 26.7493 19.1708 31.1766C16.152 35.4 11.6243 39.1291 5.70223 42.2722Z"
                        fill="#AF493E"
                      />
                    </svg>
                    <h1 className="font-medium text-18 text-center text-main-black mt-5 mb-8">
                      I move between cities, and Care Nova works everywhere.
                      Total lifesaver!
                    </h1>
                    <img
                      src="assets/images/iyer.png"
                      alt=""
                      className="mx-auto w-[56px] rounded-full"
                    />
                    <h1 className="font-semibold text-18 text-main-black text-center mt-3">
                      Aditya Kulkarni
                    </h1>
                    <p className="text-paragraph text-center font-medium text-sm">
                      Pune
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="relative w-fit mx-auto flex items-center">
            <div className="flex justify-between absolute w-full">
              <button className="group h5-story-prev w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#AF493E10] border-[#AF493E20] overflow-hidden before:inline-block before:w-11 before:h-11 before:border-[1.5px] before:border-[#AF493E] before:bg-[#AF493E] relative before:absolute before:z-0 before:-right-12 hover:before:right-0 before:transition-all before:duration-300">
                <svg
                  className="relative z-10 pointer-events-none"
                  width={12}
                  height={10}
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="stroke-[#AF493E] group-hover:stroke-white"
                    d="M4.75 9L1 5.25M1 5.25L4.75 1.5M1 5.25L11 5.25"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button className="group rotate-180 h5-story-next w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#AF493E10] border-[#AF493E20] overflow-hidden before:inline-block before:w-11 before:h-11 before:border-[1.5px] before:border-[#AF493E] before:bg-[#AF493E] relative before:absolute before:z-0 before:-right-12 hover:before:right-0 before:transition-all before:duration-300">
                <svg
                  className="relative z-10 pointer-events-none"
                  width={12}
                  height={10}
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="stroke-[#AF493E] group-hover:stroke-white"
                    d="M4.75 9L1 5.25M1 5.25L4.75 1.5M1 5.25L11 5.25"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="h5-story-pagination h7-pagination px-10" />
          </div>
        </div>
      </section>

      {/* testimonials end */}

      {/* faq start */}
      <section className="py-[70px] sm:py-[130px] bg-white max-w-full">
        <div className="theme-container mx-auto grid grid-cols-6 lg:grid-cols-12 sm:gap-[63px]">
          <div className="col-span-6">
            <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit">
              FAQs
            </h1>
            <h2 className="font-semibold text-24 sm:text-48 text-main-black mt-5">
              Frequently Asked Questions &amp; Answer
            </h2>
            <p className="text-paragraph mt-[30px] max-w-[424px] mb-[18px]">
              IT businesses help organizations develop and implement robust
              business continuity plans disaster
            </p>
            <Link to="/plans">
              <div className="home-two-btn-bg py-4 mt-[40px] group bg-[#AF493E] border-[1px] border-[#AF493E]">
                <span className="text-base text-white group-hover:text-[#AF493E] transition-all duration-300 font-semibold font-inter relative z-10">
                  Explore Our Plans
                </span>
                <svg
                  className="relative z-10"
                  width={7}
                  height={12}
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#AF493E] transition-all duration-300"
                    d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-span-6 mt-[60px] md:mt-0 ">
            <div data-aos="fade-up" className="flex flex-col gap-2.5 w-full">
              {/* faq single start  */}
              <div
                className="py-5 px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit h-fit border border-[#AF493E15] bg-[#AF493E10] active-h7-faq"
                name="faq-1"
              >
                <div className="w-full flex justify-between items-center pointer-events-none h-fit">
                  <h1 className="font-semibold sm:text-18 text-main-black">
                    What is an OPD plan?
                  </h1>
                  <svg
                    width={19}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#AF493E"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className="mt-3.5 text-paragraph pointer-events-none h-fit">
                  OPD (Outpatient Department) plans cover everyday medical needs
                  like doctor visits, diagnostics, and minor treatments —
                  without hospitalization.
                </p>
              </div>
              {/* faq single end  */}
              {/* faq single start  */}
              <div
                className="py-5 px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit border border-[#AF493E15]"
                name="faq-2"
              >
                <div className="w-full flex justify-between items-center pointer-events-none">
                  <h1 className="font-semibold sm:text-18 text-main-black">
                    How is a wellness plan different?
                  </h1>
                  <svg
                    width={19}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#AF493E"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className="mt-3.5 text-paragraph pointer-events-none">
                  Wellness plans focus on preventive care — regular check-ups,
                  fitness, nutrition, and mental well-being.
                </p>
              </div>
              {/* faq single end  */}
              {/* faq single start  */}
              <div
                className="py-5 px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit h-fit border border-[#AF493E15]"
                name="faq-3"
              >
                <div className="w-full flex justify-between items-center pointer-events-none h-fit">
                  <h1 className="font-semibold sm:text-18 text-main-black">
                    Can I use Care Nova plans in any city?
                  </h1>
                  <svg
                    width={19}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#AF493E"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className="mt-3.5 text-paragraph pointer-events-none h-fit">
                  Yes! We have a growing partner network across India.
                </p>
              </div>
              {/* faq single end  */}
              {/* faq single start  */}
              <div
                className="py-5 px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit border border-[#AF493E15]"
                name="faq-4"
              >
                <div className="w-full flex justify-between items-center pointer-events-none">
                  <h1 className="font-semibold sm:text-18 text-main-black">
                    Is this an insurance policy?
                  </h1>
                  <svg
                    width={19}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#AF493E"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className="mt-3.5 text-paragraph pointer-events-none">
                  No, our plans are not insurance. They offer prepaid healthcare
                  services at discounted rates with direct benefits to you.
                </p>
              </div>
              {/* faq single end  */}
            </div>
          </div>
        </div>
      </section>
      {/* faq here */}


      {/* Contact start here */}
      <section className="py-[70px] sm:py-[130px] bg-[#FEF9F6]">
        <div className="theme-container mx-auto grid grid-cols-6 lg:grid-cols-12 sm:gap-[63px]">
          <div className="col-span-6">
            <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit">
              Connect With Us
            </h1>
            <h2 className="font-semibold text-24 sm:text-48 text-main-black mt-5">
              Contact Us Now
            </h2>
          </div>
          <div className="col-span-6 mt-[60px] md:mt-0 ">
            <div class="border border-purple/10 bg-[#FFFFFF] rounded-[10px] p-4 md:p-[50px] max-md:mt-[80px]">
              <h1 class="text-[30px] tracking-tight font-semibold text-main-black pb-6">
                Send Us Message
              </h1>
              <p class="text-paragraph mb-[30px]">All fields are required.</p>
              <form onSubmit={onSendEmail}
                action="#"
                class="grid grid-cols-6 md:grid-cols-12 gap-[30px]"
              >
                <input
                  type="text" value={notification?.name}
                  required onChange={(e) => setNotification({ ...notification, name: e.target.value })}
                  placeholder="Full Name"
                  class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                />
                <input
                  type="email" value={notification?.email}
                  required onChange={(e) => setNotification({ ...notification, email: e.target.value })}
                  placeholder="Email Id"
                  class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                />
                <input
                  type="tel" value={notification?.phone}
                  required onChange={(e) => setNotification({ ...notification, phone: e.target.value })}
                  placeholder="Phone Number"
                  class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                />
                <input
                  type="text" value={notification?.subject}
                  required onChange={(e) => setNotification({ ...notification, subject: e.target.value })}
                  placeholder="Subject"
                  class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                />
                <textarea value={notification?.message || ""}
                  required onChange={(e) => setNotification({ ...notification, message: e.target.value })}
                  placeholder="Message"
                  class="col-span-6 md:col-span-12 focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent h-[83px]"
                ></textarea>

                <div class="col-span-6 md:col-span-12">
                  <button class="home-two-btn-bg py-3 group bg-[#af493e] border-[#af493e] inline-flex">
                    <span class="text-base text-white group-hover:text-[#af493e] transition-all duration-300 font-inter relative z-10">
                      Send Message
                    </span>
                    <svg
                      class="relative z-10"
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="group-hover:stroke-[#af493e] transition-all duration-300"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Contact ends here */}
    </main>
  );
};

export default HomePage;
